import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Gear20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_819)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25ZM7.75 10C7.75 8.75736 8.75736 7.75 10 7.75C11.2426 7.75 12.25 8.75736 12.25 10C12.25 11.2426 11.2426 12.25 10 12.25C8.75736 12.25 7.75 11.2426 7.75 10Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5228 1C12.5228 0.447715 12.075 0 11.5228 0H8.47748C7.92519 0 7.47748 0.447714 7.47748 0.999999V2.22126C7.47748 3.7574 5.81755 4.72008 4.48423 3.9572L3.38398 3.32766C2.90726 3.0549 2.29977 3.21767 2.02329 3.69225L0.50745 6.2942C0.227902 6.77404 0.392877 7.38975 0.87489 7.66555L1.92089 8.26403C3.26322 9.03208 3.26322 10.9679 1.92089 11.7359L0.874885 12.3344C0.392872 12.6102 0.227899 13.2259 0.507446 13.7057L2.02329 16.3077C2.29976 16.7823 2.90725 16.945 3.38397 16.6723L4.48423 16.0427C5.81755 15.2799 7.47748 16.2425 7.47748 17.7787V19C7.47748 19.5523 7.92519 20 8.47748 20H11.5228C12.075 20 12.5228 19.5523 12.5228 19V17.7787C12.5228 16.2425 14.1827 15.2799 15.516 16.0427L16.6163 16.6723C17.093 16.945 17.7005 16.7823 17.9769 16.3077L19.4928 13.7057C19.7723 13.2259 19.6074 12.6102 19.1253 12.3344L18.0793 11.7359C16.737 10.9679 16.737 9.03208 18.0793 8.26403L19.1253 7.66555C19.6074 7.38975 19.7723 6.77404 19.4928 6.2942L17.9769 3.69225C17.7005 3.21767 17.093 3.0549 16.6163 3.32766L15.516 3.9572C14.1827 4.72008 12.5228 3.75741 12.5228 2.22127V1ZM8.97748 2.22126V1.5H11.0228V2.22127C11.0228 4.90951 13.9276 6.59419 16.2609 5.25914L16.9306 4.87599L17.943 6.61386L17.3344 6.96208C14.9853 8.30616 14.9853 11.6938 17.3344 13.0378L17.943 13.3861L16.9306 15.1239L16.2609 14.7408C13.9276 13.4057 11.0228 15.0904 11.0228 17.7787V18.5H8.97748V17.7787C8.97748 15.0904 6.0726 13.4057 3.7393 14.7408L3.06964 15.1239L2.0572 13.3861L2.66582 13.0378C5.01491 11.6938 5.01491 8.30616 2.66582 6.96208L2.05721 6.61385L3.06965 4.87599L3.7393 5.25915C6.0726 6.59419 8.97748 4.90951 8.97748 2.22126Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_819'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Gear20.displayName = 'Gear20';
export default Gear20;
